import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eb5f2d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-text-center" }, "Payments", -1))
const _hoisted_3 = {
  class: "p-d-flex",
  style: {"gap":"20px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "BY STATUS", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "My MONTH", -1))
const _hoisted_6 = { class: "p-d-flex p-justify-center" }
const _hoisted_7 = { class: "value p-mr-1" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "p-d-flex p-justify-center" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = {
  key: 0,
  class: "column"
}
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "p-d-flex p-align-center" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "p-d-flex p-align-center" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "p-d-flex p-justify-center" }
const _hoisted_25 = { class: "p-text-capitalize value" }
const _hoisted_26 = { class: "p-d-flex p-align-center p-justify-start" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "p-d-flex p-justify-center" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "p-d-flex p-align-center" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "p-d-flex p-justify-center" }
const _hoisted_33 = { class: "p-d-flex p-flex-column p-justify-center actions-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_Dropdown, {
          modelValue: $setup.selectedQuery,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedQuery) = $event)),
          options: $setup.queryesStatus,
          onChange: $setup.changeStatusQuery,
          optionLabel: "name",
          optionValue: "value",
          placeholder: "Select a status video"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createVNode(_component_Calendar, {
          modelValue: $setup.byMonth,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.byMonth) = $event)),
          view: "month",
          dateFormat: "mm/yy"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_DataTable, {
      value: $setup.transfers,
      responsiveLayout: "scroll",
      class: "p-mt-6 w-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Amount",
          field: "campaignId?.paymentMethod",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(data?.amount), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(data?.currency), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Per Month",
          field: "campaignId?.paymentMethod",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("pre", _hoisted_10, _toDisplayString($setup.formatDate(data?.perMonth)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Pai For",
          field: "paidFor",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            (data?.campaignId?.paymentMethod === $setup.CampaignPaymentMethod.CPI)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createTextVNode(" Android: "),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(data?.paidFor?.android), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(" IOS: "),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(data?.paidFor?.IOS), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (data?.campaignId?.paymentMethod === $setup.CampaignPaymentMethod.CPC)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createTextVNode(" Clicks: "),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(data?.paidFor?.clicks), 1)
                ]))
              : _createCommentVNode("", true),
            (data?.campaignId?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createTextVNode(" Views: "),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(data?.paidFor?.views), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "For user",
          field: "userId",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            (data?.userType === 'creator')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (data?.userId?.profile?.photo)
                      ? (_openBlock(), _createBlock(_component_Avatar, {
                          key: 0,
                          image: data?.userId?.profile?.photo,
                          class: "p-mr-2 photo"
                        }, null, 8, ["image"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(data?.userId?.name), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (data?.userType === 'agencyOwner')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (data?.userId?.agencyData?.photo)
                      ? (_openBlock(), _createBlock(_component_Avatar, {
                          key: 0,
                          image: data?.userId?.agencyData?.photo,
                          class: "p-mr-2 photo"
                        }, null, 8, ["image"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(data?.userId?.agencyData?.name), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "User Type",
          field: "userType",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(data?.userType), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Campaign",
          field: "campaignId",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_26, [
              (data?.campaignId?.photo)
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    image: data?.campaignId?.photo,
                    class: "p-mr-2 photo"
                  }, null, 8, ["image"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_27, _toDisplayString(data?.campaignId?.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Payment Method",
          field: "campaignId?.paymentMethod",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(data?.campaignId?.paymentMethod), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "brand",
          field: "brand",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_30, [
              (data?.brand?.photo)
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    image: data?.brand?.photo,
                    class: "p-mr-2 photo"
                  }, null, 8, ["image"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_31, _toDisplayString(data?.brand?.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Invoice",
          field: "creditNode",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_32, [
              (!data?.creditNode)
                ? (_openBlock(), _createBlock(_component_FileUpload, {
                    key: 0,
                    disabled: $setup.loadingUpload === data?.id,
                    mode: "basic",
                    customUpload: "",
                    onUploader: ($event: any) => ($setup.uploadInvoice(data?.id, $event)),
                    class: "p-button-secondary",
                    chooseLabel: "Upload invoice",
                    maxFileSize: 1000000,
                    auto: true
                  }, null, 8, ["disabled", "onUploader"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Download invoice",
                    class: "p-button-warning",
                    onClick: ($event: any) => ($setup.openInvoice(data))
                  }, null, 8, ["onClick"]))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Actions",
          field: "actions",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_33, [
              (data?.status !== 'paid')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Mark paid",
                    class: "p-button-success",
                    onClick: ($event: any) => ($setup.changeTransferStatus(data, 'paid'))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (data?.status !== 'active')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Resume transfer",
                    class: "p-button-danger",
                    onClick: ($event: any) => ($setup.changeTransferStatus(data, 'active'))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Paginator, {
      onPage: $setup.pageChange,
      rows: 50,
      totalRecords: $setup.totalCount
    }, null, 8, ["onPage", "totalRecords"])
  ]))
}